import { useEffect, useState } from "react";
import { userData } from "../js/utils";
import { post } from "../js/post";

export function useSupplierBrandsByFamily(family, suppliers) {
  const [list, setList] = useState([]);

  async function getData() {
    const response = await post("ListarMarcasProveedoresFamilias.php", {
      token: userData.token,
      familia: family,
      proveedores: suppliers,
    });
    setList(response);
  }

  useEffect(() => {
    getData();
  }, [JSON.stringify(family), JSON.stringify(suppliers)]);

  return list;
}
